module.exports = __webpack_public_path__ + "static/img/rotationPlot_2.63227fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rotationPlot/rotationPlot_2.jpg
// module id = ux9/
// module chunks = 0